var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list"},[_c('list',{attrs:{"addLink":_vm.addLink,"apiList":_vm.apiList,"editLink":_vm.editLink,"fs":_vm.fs,"pageMode":true,"showAction":_vm.showAction,"title":_vm.type + 's',"api":"products"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }